import Swiper from "swiper/bundle";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CreateSlider } from "butter-slider";
gsap.registerPlugin(ScrollTrigger);

export class Carousel {
	constructor({ el }) {
		this.el = el;
		this.dom = {
			container: el.querySelector(".carousel_container"),
			slides: Array.from(el.querySelectorAll(".carousel_slide")),
			controls: {
				prev: el.querySelector(".carousel_control.-prev"),
				next: el.querySelector(".carousel_control.-next")
			}
		};

		this.state = {
			activeIndex: 0,
			total: this.dom.slides.length,
			anim: false
		};

		this.init();
	}

	init() {
		gsap.set(this.dom.slides.slice(1), {
			xPercent: 100
		});

		const { prev, next } = this.dom.controls;

		prev.addEventListener("click", () => this.handleClick(-1));
		next.addEventListener("click", () => this.handleClick(1));
	}

	animate(activeEl, nextEl, diff, callback) {
		const params = {
			duration: 0.8,
			ease: "power2.inOut"
		};

		const tl = gsap.timeline({
			onComplete: callback
		});

		tl.fromTo(
			nextEl,
			{
				xPercent: 100 * diff
				// rotateZ: 30 * diff
			},
			{
				xPercent: 0,
				// rotateZ: 0,
				...params,
				onComplete: callback
			}

		);

		if(document.querySelectorAll('.tax-featurepost').length > 0){
			return;
		}

		tl.fromTo(
			nextEl.querySelectorAll(".o-line > *"),
			{
				yPercent: 100,
			},
			{
				yPercent: 0,
				duration: 0.64,
				ease: "power2.out",
				stagger: 0.16,
				overwrite: true
			},
			">-0.32"
		);
	}

	getIndex(curr, diff, total = this.state.total) {
		const t = (curr + diff) % total;
		return t < 0 ? t + total : t;
	};

	setClass(el, className) {
		el.classList.remove("-curr", "-next");

		if ( className ) {
			el.classList.add(className);
		}
	}

	handleClick(diff) {
		if ( this.state.anim ) {
			return;
		}

		this.state.anim = true;

		const { activeIndex } = this.state;
		const nextIndex = this.getIndex(activeIndex, diff);
		const activeEl = this.dom.slides[activeIndex];
		const nextEl = this.dom.slides[nextIndex];

		// this.setZ(activeEl, nextEl);
		this.setClass(activeEl, "-curr");
		this.setClass(nextEl, "-next");

		this.animate(activeEl, nextEl, diff, () => {
			this.setClass(activeEl);
			this.setClass(nextEl, "-curr");

			this.state.activeIndex = nextIndex;
			this.state.anim = false;
		});
	}

}

export class LoadTransition {
	constructor({ target }) {
		this.el = document.querySelector(".load-transition");
		this.target = document.getElementById(target);
		if (this.target) {
			this.targetBCR = this.target.getBoundingClientRect();
		}
	}

	animate(callback) {
		if (!this.el || !this.target) return;
		
		const { top, left, width, height } = this.targetBCR;

		gsap
			.timeline()
			.to(this.el, {
				x: left,
				y: top,
				width,
				height,
				duration: 1.2,
				ease: "power1.out"
			})
			.to(this.el, {
				autoAlpha: 0,
				duration: 0.5,
				ease: "power1.out",
				onStart: callback
			});
	}
}


export function Slider() {
	const els = document.querySelectorAll("[data-slider]");

	els.forEach((el) => {
		const dom = {
			slider: el.querySelector(".slider_slides"),
			slides: el.querySelectorAll(".slider_item"),
			progressBar: el.querySelector(".slider_progress_bar")
		};

		const toggleDragState = (dragging) => {
			gsap.to(dom.slides, {
				scale: dragging ? 0.96 : 1
			});
		};

		const initSlider = () => {
			return new CreateSlider({
				container: el,
				slider: dom.slider,
				dragSpeed: 1.2,
				smoothAmount: 0.1,
				getScrollPercent: (e) => {
					dom.progressBar.style.width = `${e}%`;
				},
				mouseDown: () => toggleDragState(true),
				mouseUp: () => toggleDragState(false)
			});
		};

		if (dom.slides && dom.slides.length > 0) {
			gsap.from(dom.slides, {
				scrollTrigger: el,
				opacity: 0,
				xPercent: -60,
				yPercent: (i) => (i % 2 === 0 ? -20 : 20),
				stagger: {
					amount: 0.6,
					from: "end"
				},
				duration: 0.8,
				ease: "power1.out",
				onComplete: initSlider
			});
		} else {
			initSlider();
		}
	});
}

export function HomeCollectionSlider() {
	const els = document.querySelectorAll(".featurecollection_slider");

	els.forEach((el) => {
		const dom = {
			slides: el.querySelectorAll(".swiper-slide"),
			progressBar: el.querySelector(".slider_progress_bar"),
			inTransition: false,
			
		};

		const toggleDragState = (dragging) => {
			return gsap.to(dom.slides, {
				scale: dragging ? 0.96 : 1
			});
		};

		new Swiper(el, {
			grabCursor: true,
			touchRatio: 0.9,
			slidesPerView: 1,
			spaceBetween: 30,
			slidesOffsetAfter: 30,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			 },
			progress: {
				watchSlidesProgress: true
			},
			breakpoints: {
				540: {
					slidesPerView: 2,
					touchRatio: 0.9,
					freeMode: {
						freeModeMomentumRatio: 0.5,
						freeModeMomentumVelocityRatio: 0.5
					}
				}
			},
			on: {
				init() {
					if (dom.slides && dom.slides.length > 0) {
						gsap.from(dom.slides, {
							scrollTrigger: el,
							opacity: 0,
							xPercent: -60,
							yPercent: (i) => (i % 2 === 0 ? -20 : 20),
							stagger: {
								amount: 0.6,
								from: "end"
							},
							duration: 0.8,
							ease: "power1.out"
						});
					}
				},
				touchMove() {
					toggleDragState(true);
				},
				touchEnd() {
					toggleDragState(false);
				},
				transitionStart() {
					dom.inTransition = true;
				},
				transitionEnd() {
					dom.inTransition = false;
				},
				click(swiper, event) {
					if(dom.inTransition){
						event.preventDefault();
					}
				},
				progress(swiper, progress) {
					gsap.to(dom.progressBar, {
						width: () => `${progress * 100}%`
					})
				}
			}
		});
	});
}

export class ScrollLock {
	constructor() {
		this.dom = {
			container: "[data-scroll-lock]",
			els: Array.from(
				document.querySelectorAll("[data-scroll-lock] > .scroll-lock")
			)
		};

		this.upcomingEls = this.dom.els.slice(1);
		this.count = this.dom.els.length - 1;

		this.initialAnim();
		this.scrollAnim();
	}

	initialAnim() {
		const el = this.dom.els[0];
		if (!el) return;

		const bg = el.querySelector(".scroll-lock_bg");
		const textLines = el.querySelectorAll(".scroll-lock_text .o-line > *");

		const tl = gsap.timeline({ scrollTrigger: this.dom.container });

		if (bg) {
			tl.from(bg, {
				width: "0%",
				duration: 0.8,
				ease: "power1.in"
			});
		}

		if (textLines && textLines.length > 0) {
			tl.from(textLines, {
				yPercent: 100,
				duration: 0.4,
				stagger: 0.06,
				ease: "power1.out"
			});
		}
	}

	scrollAnim() {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.dom.container,
				scrub: 0.2,
				pin: true,
				start: "top top",
				snap: {
					snapTo: 1 / this.count,
					delay: 0
				},
				end: `+=${200 * this.count}%`
			}
		});

		this.upcomingEls.forEach((el) => {
			if (!el) return;

			tl.fromTo(el,
				{ autoAlpha: 0, duration: 0.001 },
				{ autoAlpha: 1, duration: 0.001 }
			);

			const bg = el.querySelector(".scroll-lock_bg");
			if (bg) {
				tl.fromTo(
					bg,
					{ width: "0%" },
					{ width: "100%", duration: 0.5, ease: "power1.in" }
				);
			}

			const overlay = el.querySelector('.scroll-overlay');
			if (overlay) {
				tl.fromTo(
					overlay,
					{ autoAlpha: 0 },
					{ autoAlpha: 1, duration: 0.3, ease: "power1.in" }
				);
			}

			const textLines = el.querySelectorAll(".scroll-lock_text .o-line > *");
			if (textLines && textLines.length > 0) {
				tl.from(
					textLines,
					{ yPercent: 100, duration: 0.1, stagger: 0.06, ease: "power1.in" },
					"<0.4"
				);
			}
		});
	}
}
